module.exports = __webpack_public_path__ + "static/img/16.709f481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/16.png
// module id = 0Ydy
// module chunks = 0